/**
 * Capitalize the first letter of a string
 * @param {string} str
 * @returns {string}
 */
export function capitalize (str) {
  if (!str) return str
  if (typeof str !== 'string') return str

  return str.charAt(0).toUpperCase() + str.slice(1)
}
